var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerConfigLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 4.58325C10.7467 4.58325 10 5.32825 10 6.24992V11.2499C10 12.1716 10.7467 12.9166 11.6667 12.9166C12.5867 12.9166 13.3333 12.1716 13.3333 11.2499V6.24992C13.3333 5.32825 12.5867 4.58325 11.6667 4.58325Z",
    fill: "#FCBA46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 4.58325C27.4132 4.58325 26.6665 5.32825 26.6665 6.24992V11.2499C26.6665 12.1716 27.4132 12.9166 28.3332 12.9166C29.2532 12.9166 29.9998 12.1716 29.9998 11.2499V6.24992C29.9998 5.32825 29.2532 4.58325 28.3332 4.58325Z",
    fill: "#FCBA46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 10H6.25C5.56 10 5 10.56 5 11.25V38.75C5 39.15 5.19167 39.5267 5.515 39.76C5.83833 39.9967 6.255 40.0633 6.635 39.9383L20 35.615L33.365 39.94C33.4917 39.98 33.62 40 33.75 40C34.0117 40 34.27 39.9183 34.485 39.76C34.8083 39.5267 35 39.15 35 38.75V11.25C35 10.56 34.44 10 33.75 10Z",
    fill: "#F66127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75 0H1.25C0.56 0 0 0.56 0 1.25V3.75C0 5.35833 1.30833 6.66667 2.91667 6.66667H37.0833C38.6917 6.66667 40 5.35833 40 3.75V1.25C40 0.56 39.44 0 38.75 0Z",
    fill: "#2CBFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0832 18.3333H12.9165C12.2265 18.3333 11.6665 17.7733 11.6665 17.0833C11.6665 16.3933 12.2265 15.8333 12.9165 15.8333H27.0832C27.7732 15.8333 28.3332 16.3933 28.3332 17.0833C28.3332 17.7733 27.7732 18.3333 27.0832 18.3333Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0832 22.5H12.9165C12.2265 22.5 11.6665 21.94 11.6665 21.25C11.6665 20.56 12.2265 20 12.9165 20H27.0832C27.7732 20 28.3332 20.56 28.3332 21.25C28.3332 21.94 27.7732 22.5 27.0832 22.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0832 26.6665H12.9165C12.2265 26.6665 11.6665 26.1065 11.6665 25.4165C11.6665 24.7265 12.2265 24.1665 12.9165 24.1665H27.0832C27.7732 24.1665 28.3332 24.7265 28.3332 25.4165C28.3332 26.1065 27.7732 26.6665 27.0832 26.6665Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0832 30.8333H12.9165C12.2265 30.8333 11.6665 30.2733 11.6665 29.5833C11.6665 28.8933 12.2265 28.3333 12.9165 28.3333H27.0832C27.7732 28.3333 28.3332 28.8933 28.3332 29.5833C28.3332 30.2733 27.7732 30.8333 27.0832 30.8333Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerConfigLogo);
export default __webpack_public_path__ + "static/media/bannerConfigLogo.e0a0a6b045ea3796572addc757094bc7.svg";
export { ForwardRef as ReactComponent };